import { WallPlaybackPage } from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';

/**
 * A site's Live Wall → Recorded: up to six of the selected site's cameras playing the same
 * moment, streamed through the tunnel. Shared with the local node's wall; the site is bound in
 * the `wallPlayback` adapter, and a site switch starts the wall over (another site's cameras).
 */
export default function SiteWallPlaybackPage() {
  const { selectedNode, selectedNodeId } = useNode();
  return (
    <WallPlaybackPage
      livePath="/live-wall"
      siteName={selectedNode?.name}
      blocked={!selectedNodeId}
      nodeKey={selectedNodeId || ''}
    />
  );
}
